import { motion } from "framer-motion";
import { useSite } from "@/context/SiteContext";

const EASE = [0.22, 1, 0.36, 1];

export const Story = () => {
  const { content, t, lang } = useSite();

  return (
    <section id="story" data-testid="story-section" className="relative py-32 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
          className="text-xs font-bold uppercase tracking-[0.25em] text-orange-500"
        >
          {lang === "zh" ? "我们的故事" : "Our Story"}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1, ease: EASE }}
          className="mt-4 font-display font-extrabold tracking-tight text-4xl sm:text-5xl text-slate-900 max-w-2xl"
        >
          {lang === "zh" ? "三个章节，一份初心" : "Three Chapters, One Mission"}
        </motion.h2>

        <div className="mt-20 space-y-24">
          {content.story.map((ch, i) => (
            <motion.div
              key={ch.num + i}
              data-testid={`story-chapter-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, ease: EASE }}
              className={`grid md:grid-cols-12 gap-6 md:gap-12 items-start ${i % 2 === 1 ? "" : ""}`}
            >
              <div className={`md:col-span-4 ${i % 2 === 1 ? "md:order-2 md:text-right" : ""}`}>
                <span className="font-mono2 font-medium text-7xl sm:text-8xl text-sky-200 leading-none select-none">
                  {ch.num}
                </span>
              </div>
              <div className={`md:col-span-8 ${i % 2 === 1 ? "md:order-1" : ""} ${i % 2 === 0 ? "md:pt-6" : "md:pt-6"}`}>
                <h3 className="font-display font-bold tracking-tight text-2xl sm:text-3xl text-slate-900">
                  {t(ch, "title")}
                </h3>
                <p className="mt-5 text-base sm:text-lg leading-relaxed text-slate-600 max-w-xl">
                  {t(ch, "body")}
                </p>
                <div className="mt-6 h-1 w-16 rounded-full bg-orange-500" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
